var React = require('react');

function ExitWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9996 14.5343L1.84779 25.6828C1.42435 26.1061 0.738429 26.1055 0.31561 25.6803C-0.10721 25.2552 -0.105971 24.5681 0.318086 24.1442L11.4655 13L0.318086 1.85518C-0.105352 1.43188 -0.106591 0.744179 0.31561 0.319018C0.73781 -0.106143 1.42373 -0.106764 1.84779 0.316535L12.9996 11.4657L24.1514 0.317156C24.5748 -0.106143 25.2607 -0.105522 25.6835 0.319639C26.1064 0.7448 26.1051 1.43188 25.6811 1.8558L14.5336 13L25.6811 24.1448C26.1045 24.5681 26.1057 25.2558 25.6835 25.681C25.2613 26.1061 24.5754 26.1067 24.1514 25.6834L12.9996 14.5343Z","fill":"#fff"}));
}

ExitWhite.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = ExitWhite;

ExitWhite.default = ExitWhite;
